import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { sendDataLayer } from "../../utils/functions";
import Icon from "../../components/atoms/Icon";
import { StateController } from './../../App';
 import useWidth from '../../hooks/useWidth'

function Footer({
  footerType,
  links,
  // linksText,
  content,
  logOutAction,
  loggedIn,
}) {
   const { width } = useWidth();
  const { context } = useContext(StateController);

  const closeSession = (e) => {
    logOutAction()
    console.log("aqui0");
    sendDataLayer({ datalayer: { event: "footer", text: e.target.textContent, link: window.location.href }, repeat: true })
  }
  const handler = (e, link) => {
    link.onClick()
    console.log("aqui1");

    sendDataLayer({
      datalayer: {
        event: "footer",
        text: e.target.textContent,
        link: link.link,
      },
      repeat: true,
    });
  }

  const handlerA = (e, link) => {
    e.preventDefault();
    console.log("aqui2");
    sendDataLayer({
      datalayer: {
        event: "footer",
        text: e.target.textContent,
        link: link,
      },
      repeat: true,
    });

    setTimeout(() => {
      window.open(link, "_blank", "noreferrer");
    }, 300);
  }
  return (
    <div
      className={`mc-footer-container mc-footer-container-type-${footerType}`}
    >
      {footerType === 1 && (
        <div className="mc-footer-container__bg">
          <div className="mc-footer-container__section">
            {links && links[0] && (
              <ul className="mc-footer-container__section--links">
                {links.map((link, index) => {
                  return (
                    <Link
                      onClick={(e) => {
                        handler(e, link)
                      }}
                      key={index}
                    >
                      {link.text}
                    </Link>
                  );
                })}
              </ul>
            )}

            {/* {window.location.pathname === '/' &&
              <div className="mc-footer-container__tarjetas">
                <img src="/assets/images/tarjetas.png" alt="tarjetasBogota"/>
              </div>
            } */}

            <div className="mc-footer-container__text flex">
              <p><b>Contacto:</b></p>
              <p>
                <b>Si tienes dudas con tus transacciones comunícate en Medellín:</b> (604) 444 3727  •  <b>Bogotá:</b> (601) 482 4804  •  <b>Cali:</b> (602) 380 8933  •  <b>Línea nacional:</b> 01 8000 978 888. <b>De lunes a sábado:</b> 8:00 a.m. a 6:00 p.m.  •  <b>Domingos y festivos:</b> solo estará habilitado el IVR (audio respuesta).
              </p>
            </div>

            <hr />

            <div className="mc-footer-container__text" dangerouslySetInnerHTML={{ __html: content }} />
            <hr></hr>
            {!context ?
              <div className="mc-footer-container__text"><p><a href="https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html" target="_blank" rel="noreferrer" onClick={(e) => { handlerA(e, 'https://www.mastercard.com.co/es-co/consumidores/conozca-nuestras-ofertas-y-promociones/every-day-value.html') }}>Conoce los beneficios que Mastercard tiene para ofrecerte y disfrútalos.</a></p></div> :
              <div className="mc-footer-container__text"><p><a href='https://www.mastercard.com/co/es/personal/experience-mastercard/beneficio-para-tu-dia-a-dia.html' target="_blank" rel="noreferrer">Conoce los beneficios que Mastercard tiene para ofrecerte y disfrútalos.</a></p></div>
            }
            {/* <div className="mc-footer-container__imgs">
              <a href="https://www.youtube.com/user/BancodeBogota" onClick={(e) => {handlerA(e, 'https://www.youtube.com/user/BancodeBogota')}}><img src="/assets/images/youtube.svg" alt="logo youtube"/></a>
              <a href="https://www.instagram.com/bancodebogota/" onClick={(e) => {handlerA(e, 'https://www.instagram.com/bancodebogota/')}}><img src="/assets/images/instagram.svg" alt="logo instagram"/></a>
              <a href="https://www.linkedin.com/company/banco-de-bogota/" onClick={(e) => {handlerA(e,'https://www.linkedin.com/company/banco-de-bogota/')}}><img src="/assets/images/linkedin.svg" alt="logo linkedIn"/></a>
              <a href="https://www.facebook.com/BancodeBogota/" onClick={(e) => {handlerA(e, 'https://www.facebook.com/BancodeBogota/')}}><img src="/assets/images/facebook.svg" alt="logo facebook"/></a>
              <a href="https://x.com/bancodebogota" onClick={(e) => {handlerA(e, 'https://x.com/bancodebogota')}}><img src="/assets/images/twitter.svg" alt="logo twitter"/></a>
              <a href="https://api.whatsapp.com/send?phone=573182814679&text=Hola,%20%C2%BFC%C3%B3mo%20me%20puedes%20ayudar?" onClick={(e) => {handlerA(e, 'https://api.whatsapp.com/send?phone=573182814679&text=Hola,%20%C2%BFC%C3%B3mo%20me%20puedes%20ayudar?')}}><img src="/assets/images/whatsapp.svg" alt="logo whatsapp"/></a>
            </div> */}
            {/* <ul className="mc-footer-container__section--banca">
              {width > 992
              ? <>
                  <a href="https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app')}}>
                    Banca App <Icon name='banca-app' />
                  </a>
                  <a href="https://www.bancodebogota.com/empresas" onClick={(e) => {handlerA(e, 'https://www.bancodebogota.com/empresas')}}>
                    <Icon name='banca-virtual' /> Banca Virtual
                  </a>
                  <a href="https://virtual.bancodebogota.co/" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/')}}>
                    Zona transaccional
                  </a>
                </>

              : <>
                  <a href="https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app" onClick={(e) => {handlerA(e, 'https://virtual.bancodebogota.co/ingreso/ayuda#descargar-app')}}>
                    Banca App <Icon name='banca-app' />
                  </a>
                  <a href="https://www.bancodebogota.com/empresas" onClick={(e) => {handlerA(e, 'https://www.bancodebogota.com/empresas')}}>
                    <Icon name='banca-virtual' /> Banca Virtual
                  </a>
                </>
              }
            </ul> */}
            {/* {width <= 992 &&
              <div className="transaccional">
                <a href="https://virtual.bancodebogota.co/" onClick={(e) => { handlerA(e, 'https://virtual.bancodebogota.co/') }}>
                  Zona transaccional
                </a>
              </div>
            } */}
            {loggedIn && context &&
              <>
                <hr></hr>
                <div className="mc-footer-close" onClick={closeSession}>
                  <span>
                    Salir <Icon name='close_session' />
                  </span>
                </div>
              </>
            }
          </div>
          <div className="mc-final-footer">
            <div className="mc-footer-container__final">

              <div className="footer-center">
                <div className="footer-logos">
                  <img src="/assets/images/vigilado.png" alt="Logo Vigilado" className="vigilado" />
                  <img src="/assets/images/tuya.png" alt="Logo Tuya" className="logo-tuya" />
                  <img src="/assets/images/MC1.png" alt="Logo Mastercard" className="logo-mc" />
                  { width <= 992 && <img src="/assets/images/TarjetaCarulla.svg" alt="Tarjeta Éxito" className="logo-carulla" />}
                </div>
                  { width <= 992 && <img src="/assets/images/Logos.svg" alt="Tarjeta Éxito" className="logo-exito" />}

              </div>
              <span className="footer-rights">Tuya • Todos los derechos reservados 2026</span>

              <div className="footer-logos-right">
                <img src="/assets/images_ty/Logos.svg" alt="Tarjeta Éxito" className="logo-estandar" />
                { width > 992 && <img src="/assets/images/Logos.svg" alt="Tarjeta Éxito" className="logo-exito" />}
                { width > 992 && <img src="/assets/images/TarjetaCarulla.svg" alt="Tarjeta Éxito" className="logo-carulla" />}
              </div>
            </div>
          </div>


        </div>
      )}
    </div>
  );
}

export default Footer;
